import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

type FetchByProductType = {
    productId: string,
    createdAt?: {
        between: string[]
    }
}

export type InvoiceProductDataType = Partial<ApiSchema["InvoiceProduct"]["type"] & EDocumentProductDataType>;
class Api extends GenericModelApi<"InvoiceProduct", InvoiceProductDataType> {

    async fetchAllByProductId(productId: string, selectionSet?: any, startData?: string, endData?: string): Promise<FetchResponse<InvoiceProductDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listByProductIdByDate;

        let fetchQuery: FetchByProductType = {
            productId: productId
        }
        if (startData && endData) {
            fetchQuery = {
                ...fetchQuery,
                createdAt: {
                    between: [startData, endData]
                }
            }
        }

        const { data, errors, nextToken: nt } = await fetchFunction(
            fetchQuery,
            {
                limit: 1000,
                selectionSet,
                sortDirection: "DESC"
            });

        if (errors) {
            throw new ApiError("Error al obtener los abonos de factura por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }

}
export const InvoiceProductApi = new Api("InvoiceProduct", "codigo")
